<template lang="html">
  <v-app-bar dark app color="primary" elevate-on-scroll clipped-right clipped-left>
    <v-app-bar-nav-icon v-show="!hideMenu"
      name="toolbar-button-sidenav-menu"
      @click.native="toggleSidenav">
    </v-app-bar-nav-icon>

    <v-btn icon small @click="home" class="mx-3">
      <v-icon>home</v-icon>
    </v-btn>

    <v-spacer v-if="$vuetify.breakpoint.smAndDown"></v-spacer>

    <img src="../../produto/assets/img/logo.svg" alt="" class="Toolbar__Image--size">

    <v-toolbar-title class="white--text">
      <span v-if="$vuetify.breakpoint.mdAndUp" class="ml-2">Tradelinks {{ title === 'Tradelinks' ? '' : `- ${title}` }}</span>
    </v-toolbar-title>

    <v-spacer></v-spacer>

    <v-btn
      icon
      v-for="(option, index) in options"
      :key="index">
      <v-icon>{{ option.icon }}</v-icon>
    </v-btn>

    <usuario-toolbar
      :usuario="usuario"
      :mail="mail"
      :estrutura-usuario="estruturaUsuario"
      :perfil="perfil">
    </usuario-toolbar>
    <calendario-toolbar></calendario-toolbar>
    <badge></badge>
  </v-app-bar>
</template>
<script type="text/javascript">
import Badge from '../../produto/shared-components/badge/Badge';
import ManualSistema from '../../produto/shared-components/manual/ManualSistema';
import UsuarioToolbar from '../../produto/shared-components/toolbar/UsuarioToolbar';
import CalendarioToolbar from '../../produto/spa/calendario/CalendarioToolbar';

export default {
  props: {
    hideMenu: {
      type: Boolean,
      default() { return false; },
    },
    title: {
      type: String,
      default() { return ''; },
    },
    options: {
      type: Array,
      default() { return []; },
    },
    usuario: String,
    mail: String,
    estruturaUsuario: String,
    perfil: String,
    state: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      progress: 0,
      progressInterval: null,
      done: false,
      transition: true,
    };
  },
  components: {
    UsuarioToolbar,
    Badge,
    CalendarioToolbar,
    ManualSistema,
  },
  methods: {
    toggleSidenav() {
      this.$emit('TOGGLE_SIDEBAR');
    },
    home() {
      this.$emit('RESET_SIDEBAR');
      this.$router.push({ name: 'dashboard-inicial' });
    },
  },
};
</script>
<style src="../../produto/shared-components/toolbar/Toolbar.scss" lang="scss"></style>
